import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router/index'
import store from './store'
import './plugins/element.js'
import 'styles/reset.css'
import 'styles/border.css'
import 'styles/iconfont.css'
import axios from 'axios'
import VueAMap from 'vue-amap'

Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '6656a8e9810da0328783e4c374223568',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  uiVersion: '1.0.11'
})
// Vue.prototype.changeData = function () { // changeData是函数名
//   console.log('执行成功')
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
